import { QFilterGeneric } from './QFilterGeneric'

export class QFilterCentroList extends QFilterGeneric {
  name = "centro_list";
  class_name = "QFilterCentroList";
  api_name = 'centros';
  
  serialize(qfilters) {
    return (this.value || []).join(',');
  }
}
